import { Action as AnyAction } from '@reduxjs/toolkit';
import { setIsLoading, setProgress } from './loading.action';

export type LoadingState = {
    readonly isLoading: boolean;
    readonly progress: number | undefined;
};

const INITIAL_STATE: LoadingState = {
    isLoading: false,
    progress: undefined,
};

export const loadingReducer = (state = INITIAL_STATE, action: AnyAction) => {
    if (
        setIsLoading.match(action) || setProgress.match(action)) {
        return { ...state, ...action.payload };
    }

    return state;
};